module.exports = __webpack_public_path__ + "img/Medical-Fair-India.885ac081.png";